<template>
  <Base :is-loading="dataIsLoad" :base-id="'lb-refund'">
    <template #header>
      <h4 v-if="step === 1" class="modal-title">選擇退貨商品</h4>
      <h4 v-else-if="step === 2" class="modal-title">選擇退貨原因</h4>
      <h4 v-else class="modal-title">重要提醒</h4>
    </template>
    <template #body>
      <form id="form-return-products" ref="refundForm" action="/User/Order/Refund" method="POST">
        <div v-show="step === 0" class="text-center remind-text">
          <h5>
            1.若申請部分退貨後，
            <br />
            訂單金額未達免運門檻，需支付原訂單出貨運費
            <br />
            <span style="color: #c92222">含抵用點數與電子折價券，及商品部份退貨後</span>
          </h5>
          <h5>2.未達滿額贈門檻，需支付贈品原價金額</h5>
          <h5>3.未達組合優惠門檻，將恢復原價計算</h5>
          <h5 v-if="data.UseFaPoints > 0">4.未達fa points折抵門檻，需支付原本折抵金額</h5>
          <h5>
            <span v-if="data.UseFaPoints > 0">5</span>
            <span v-else>4</span>
            <span>.未達加價購門檻，加購商品將會以原價計算</span>
          </h5>
        </div>
        <div v-show="step === 1">
          <input name="TransactionID" type="hidden" :value="modalData" />
          <input name="IsCreditCard" type="hidden" :value="data.IsCreditCard" />
          <div
            v-for="(market, index) in data.Markets"
            :key="market.ID"
            :ref="'refund' + index"
            class="row refund-product-row refund-border-bottom"
            :index="index"
            :class="{ last: data.Markets.length === 1 }"
          >
            <div class="refund-block">
              <div class="refund-check-block custom-ui">
                <input
                  :id="'check-' + market.ID"
                  class="input-check-refund checkbox"
                  :class="{ disabled: isCheckGift }"
                  :checked="market.checked"
                  :value="market.ID"
                  type="checkbox"
                  name="RefundMarketCheck"
                  @click="toggleChecked(market)"
                />
                <label class="refund-checkbox" :for="'check-' + market.ID" />
              </div>
              <div class="refund-text-s1-block">
                <a class="refund-product-title" :href="market.Url">
                  {{ market.Name }} - {{ market.ColorName }} - {{ market.Size }}
                </a>
                <br />
                <div class="refund-product-price">
                  <p class="refund-product-sellprice">單價:NT$ {{ market.SellPrice }}</p>
                  <p class="refund-product-subtotal">小計:NT$ {{ market.SubTotal }}</p>
                </div>
              </div>
            </div>
            <div :ref="'block' + index" class="refund-num-s1-block">
              <span class="refund-num-title">欲退貨數量</span>
              <div
                v-if="market.Events.length !== 0 && !market.Events[0].CanScatteredRefund"
                class="refund-count-select"
              >
                <div class="unselect-txt">{{ market.Count }}</div>
                <input
                  v-if="market.checked"
                  class="refund-market-val"
                  type="hidden"
                  name="RefundMarket"
                  :value="market.ID + '_' + market.Count"
                />
              </div>
              <div v-else class="refund-count-select">
                <div :id="'selectRef' + index" :ref="'selectRef' + index" class="select-txt">
                  <a class="select-result" href="javascript:;" @click="toggleOption(index, $event)">
                    <span>{{ market.refundCount }}</span>
                    <input
                      v-if="market.checked"
                      class="refund-market-val"
                      type="hidden"
                      name="RefundMarket"
                      :value="market.ID + '_' + market.refundCount"
                    />
                  </a>
                  <ul v-if="market.openSelect" class="select-options">
                    <li
                      v-for="(item, indexInCount) in market.countOptions"
                      :key="item.value + indexInCount"
                      :class="{ selected: item.value === 0 }"
                      @click="changeValue(item.value, index)"
                    >
                      <a href="javascript:;">{{ item.text }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="step === 2">
          <div class="row refund-product-row refund-border-bottom">
            <div class="refund-block">
              <div class="refund-text-s2-block">
                <img
                  class="img-fluid refund-product-pic"
                  :src="selectedItemDetail.Cover"
                  :alt="selectedItemDetail.Name"
                />
                <div class="refund-product-title d-md-block d-none">
                  {{ selectedItemDetail.Name }} - {{ selectedItemDetail.ColorName }} -
                  {{ selectedItemDetail.Size }}
                </div>
                <div class="refund-product-title d-md-none d-block">
                  <p>{{ selectedItemDetail.Name }}</p>
                  <br />
                  <div class="d-flex">
                    <p class="mr-1">顏色: {{ selectedItemDetail.ColorName }}</p>
                    <p class="ml-1">size: {{ selectedItemDetail.Size }}</p>
                  </div>
                  <br />
                  <p>NT$ {{ selectedItemDetail.SellPrice }}</p>
                </div>
              </div>
            </div>
            <div class="refund-num-s2-block">
              <div class="refund-product-sellprice d-md-block d-none">
                NT$ {{ selectedItemDetail.SellPrice }}
              </div>
            </div>
          </div>
          <div v-for="item in selectedItem" :key="item.OrderMarketID">
            <div
              v-show="item.OrderMarketID === selectedItemDetail.ID"
              class="row refund-product-row"
            >
              <p class="remind-check-txt">(一)~(四)為退貨必備資訊,請擇一填寫,(五)為選填。</p>
              <input name="reason" type="hidden" :value="getSelectedItemReason(item)" />
              <div
                v-for="(category, categoryIndex) in reasonCheck"
                :key="category.code + categoryIndex"
                class="refund-title-category-block row col-12"
              >
                <div
                  class="refund-check-reason-block col-12 custom-ui category"
                  :class="{ open: category.check }"
                >
                  <input
                    :id="'check-reason-category-' + category.code"
                    class="input-check-refund checkbox"
                    :checked="category.check"
                    :value="category.text"
                    type="checkbox"
                    @click="toggleReasonCategory(category.code)"
                  />
                  <label class="refund-checkbox" :for="'check-reason-category-' + category.code">
                    <div>{{ category.text }}</div>
                  </label>
                </div>
                <div v-if="category.check && category.code !== 'b'">
                  <p
                    v-if="
                      category.check &&
                      category.sub.filter((element) => element.check === true).length === 0
                    "
                    class="refund-category-remind-text"
                  >
                    *請勾選至少一個小項
                  </p>
                </div>
                <div v-else-if="category.check && category.code === 'b'">
                  <p
                    v-if="category.sub.filter((element) => element.check === true).length === 0"
                    class="refund-category-remind-text"
                  >
                    *請勾選至少一個小項
                  </p>
                  <p v-else class="refund-category-remind-text">*限勾選兩個小項</p>
                </div>
                <div v-if="category.check" class="row col-12 refund-title-subcategory-block">
                  <div
                    v-for="(subCategory, subCategoryIndex) in category.sub"
                    :key="subCategory.code + subCategoryIndex"
                    class="col-sm-6 col-12 refund-reason-subcategory-block"
                  >
                    <div class="refund-check-reason-block custom-ui subcategory">
                      <input
                        :id="'check-reason-subcategory-' + category.code + subCategory.code"
                        class="input-check-refund checkbox"
                        :disabled="category.code === 'b' && !subCategory.check && upToTwoSub"
                        :checked="subCategory.check"
                        :value="subCategory.text"
                        type="checkbox"
                        @click="toggleReasonSubCategory(categoryIndex, subCategoryIndex)"
                      />
                      <label
                        class="refund-checkbox"
                        :for="'check-reason-subcategory-' + category.code + subCategory.code"
                      >
                        <div>{{ subCategory.text }}</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="category.check && category.code === 'b'"
                  class="refund-reason-other-block"
                >
                  <p class="remind-check-txt" style="padding-left: 24px; margin-bottom: 5px">
                    必填
                  </p>
                  <textarea
                    v-model="selectedItemType2Reason[fillReasonIndex]"
                    class="refund-other-input"
                    placeholder="請詳述商品退貨原因，如：口袋破洞、領口有污漬...等"
                    onkeydown="if(event.keyCode == 13) return false;"
                  />
                  <div v-if="type2ReasonOverMax" class="error">字數上限為48 字元</div>
                </div>
              </div>
              <div class="refund-reason-category-block">
                <div class="refund-reason-other-block">
                  <p>五、其他<span class="remind-check-txt">(選填)</span></p>
                </div>
              </div>
              <div class="refund-reason-other-block">
                <textarea
                  v-model="selectedItemOtherReason[fillReasonIndex]"
                  class="refund-other-input"
                  onkeydown="if(event.keyCode == 13) return false;"
                />
                <div v-if="type5ReasonOverMax" class="error">字數上限為48 字元</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isCheckGift && step > 2" class="check-gift-block">
          <div v-if="giftData.length > 0" class="py-2 text-danger">
            提醒您：退貨商品須將活動贈品寄回
          </div>
          <table class="table table-bordered row-product">
            <tr v-for="gift in giftData" :key="gift.OrderMarketID" class="tr-title">
              <td class="text-left font-weight-bold d-flex align-items-center" colspan="3">
                <div class="float-left custom-ui">
                  <input
                    :id="'check-' + gift.OrderMarketID"
                    class="input-check-refund checkbox"
                    type="checkbox"
                    name="RefundMarketCheck"
                    :value="gift.OrderMarketID"
                    style="cursor: not-allowed; pointer-events: none"
                    checked="true"
                  />
                  <label for="'check-' + gift.OrderMarketID" style="cursor: not-allowed" />
                </div>
                <div class="float-left">
                  <div>{{ gift.Name }}-{{ gift.ColorName }}-{{ gift.Size }}</div>
                  <input
                    type="hidden"
                    name="RefundMarket"
                    :value="gift.OrderMarketID + '_' + gift.Count"
                  />
                  <div>
                    <span class="text-gray-800 mb-2">{{ gift.GiftEvent.Name }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </form>
    </template>
    <template #footer>
      <div class="col">
        <div v-if="isCheckGift && step > 2" class="refund-btn-block pt-0">
          <a href="#" class="btn btn-refund-return" @click.prevent="loopStep2(-1)"> 上一步 </a>
          <input
            class="btn-refund-next-fill btn"
            type="submit"
            value="確認退貨"
            @click.prevent="submitFn()"
          />
        </div>
        <div v-if="step === 0" class="refund-btn-block pt-0">
          <a href="#" class="btn btn-refund-return" @click.prevent="closeModal">取消</a>
          <a href="#" class="btn btn-refund-next-outline" @click.prevent="step++">下一步</a>
        </div>
        <div v-if="step === 1" class="refund-btn-block pt-0">
          <a href="#" class="btn btn-refund-return" @click.prevent="step--">上一步</a>
          <a
            href="#"
            :class="{ disabled: selectedItem.length === 0 }"
            class="btn btn-refund-next-fill"
            @click.prevent="goStep2"
          >
            下一步
          </a>
        </div>
        <div v-if="step === 2" class="refund-btn-block pt-0">
          <a href="#" class="btn btn-refund-return" @click.prevent="loopStep2(-1)"> 上一步 </a>
          <a
            v-if="showNextStep"
            href="#"
            class="btn btn-refund-next-fill btn"
            :class="{ disabled: !canMoveNextItem }"
            @click.prevent="loopStep2(1)"
          >
            下一步
          </a>
          <a
            v-else
            href="#"
            class="btn btn-refund-next-fill"
            :class="{ disabled: !canMoveNextItem }"
            @click.prevent="getReservedMarkets(modalData)"
          >
            確認退貨
          </a>
        </div>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';

import useRefundList from '@global/composable/order/useRefundList';
import useModalStore from '@global/stores/useModalStore';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const {
  step,
  data,
  selectedItem,
  selectedItemType2Reason,
  selectedItemOtherReason,
  dataIsLoad,
  isCheckGift,
  giftData,
  fillReasonIndex,
  selectedItemDetail,
  reasonCheck,
  refundForm,
  type2ReasonOverMax,
  type5ReasonOverMax,
  showNextStep,
  canMoveNextItem,
  upToTwoSub,
  submitFn,
  toggleOption,
  changeValue,
  toggleChecked,
  toggleReasonCategory,
  toggleReasonSubCategory,
  goStep2,
  loopStep2,
  getReservedMarkets,
  getSelectedItemReason,
  fetchAPI,
} = useRefundList({
  transactionId: modalData.value,
});

onMounted(() => {
  fetchAPI();
});
</script>
